import {forwardRef, ButtonHTMLAttributes, ReactNode, memo} from 'react';
import classNames from 'classnames';

import './button.scss';

type Props = {
    prepend?: ReactNode;
    append?: ReactNode;
    isActive?: boolean;
    hasDot?: boolean;
    allowTextOverflow?: boolean;
};

type Attrs = Exclude<ButtonHTMLAttributes<HTMLButtonElement>, Props>;

const Button = forwardRef<HTMLButtonElement, Props & Attrs>(
    ({prepend, append, children, isActive, hasDot, allowTextOverflow = false, ...attrs}, ref) => {
        return (
            <button
                ref={ref}
                {...attrs}
                className={classNames(
                    'Button Button___transparent',
                    {'is-active': isActive, allowTextOverflow},
                    attrs.className,
                )}
            >
                {prepend && <span className='Button_prepended'>{prepend}</span>}
                <span className='Button_label'>
                    {children}
                    {hasDot && <span className='dot' />}
                </span>
                {append && <span className='Button_appended'>{append}</span>}
            </button>
        );
    },
);

export default memo(Button);
